import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'sonner'
import App from './App'
import { queryClient } from './lib/queryClient'
import { initSentry, Sentry } from './lib/sentry'
import './styles/tokens.css'
import './styles/globals.css'
import { ThemeProvider } from './lib/theme'

initSentry()

// See src/lib/auth.ts + src/lib/queryClient.ts for matching gates. Active in
// local dev AND on dev.orkestrapro.com (Kris's daily-driver surface); excludes
// any future real-production hostname automatically.
const isDiagnosticContext =
  import.meta.env.DEV ||
  (typeof window !== 'undefined' &&
   window.location.hostname === 'dev.orkestrapro.com')

const ErrorFallback = (
  <div style={{ minHeight: '100vh', background: '#0a0a0f', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
    <div style={{ textAlign: 'center', maxWidth: 360 }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 12px', letterSpacing: '-0.02em' }}>Something went wrong</h1>
      <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', margin: '0 0 20px', lineHeight: 1.5 }}>
        The page failed to render. Refresh to try again — if it keeps happening, drop a note to <a href="mailto:hello@orkestrapro.com" style={{ color: '#a78bfa', textDecoration: 'none' }}>hello@orkestrapro.com</a>.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '10px 20px', background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', border: 'none', borderRadius: 10, color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}
      >
        Refresh
      </button>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <App />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#13111e',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: 'rgba(255,255,255,0.9)',
                  borderRadius: '12px',
                  fontSize: '13px',
                },
              }}
            />
          </BrowserRouter>
        </ThemeProvider>
        {isDiagnosticContext && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)